var setNewsletterSignup = function () {
  var form = document.querySelectorAll('.js-newsletter-signup-form')[0];

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formData = new FormData(form);
      var jsonData = {};

      formData.forEach(function (value, key) {
        jsonData[key] = value;
      });

      fetch(form.getAttribute('data-update-url'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonData)
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function (data) {
          document.querySelector('.js-newsletter-form-thanks').classList.remove('hidden');
          document.querySelector('.js-newsletter-form-result').classList.add('hidden');

          window.dataLayer.push({
            "event": "Newsletter Subscription"
          });
        })
        .catch(function (error) {
          document.querySelector('.js-newsletter-form-result').innerHTML = "<p class=\"leading-5 text-base text-white\">Server not responding, please try again later</p>";
          console.error('Fetch error:', error);
        });
    });

    document.getElementById('newsletter-submit-close').addEventListener('click', function (e) {
      e.preventDefault();

      document.getElementsByClassName('js-newsletter-signup-container')[0].style.display = 'none';
    });

  }
}
